/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Demo_Skipped_TagInputs */

const en_funnel_demo_skipped_tag = /** @type {(inputs: Funnel_Demo_Skipped_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SKIPPED`)
};

const es_funnel_demo_skipped_tag = /** @type {(inputs: Funnel_Demo_Skipped_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OMITIDO`)
};

/**
* | output |
* | --- |
* | "SKIPPED" |
*
* @param {Funnel_Demo_Skipped_TagInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_demo_skipped_tag = /** @type {((inputs?: Funnel_Demo_Skipped_TagInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Demo_Skipped_TagInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_demo_skipped_tag(inputs)
	return en_funnel_demo_skipped_tag(inputs)
});